/* eslint-disable @typescript-eslint/no-namespace */

export namespace Viewing {
  export namespace Extensions {
    export const SCOPES_INITIALIZED_EVENT: string = "scopesInitialized";
    export const SCOPES_UNINITIALIZED_EVENT: string = "scopesUninitialized";
    export const SCOPES_SELECTION_CHANGED_EVENT: string = "scopesSelection";
  }
}
